/**
 * Cuentas de la barra de categorías fija de la tienda online (spec 2026-10-19 §4).
 * Puras, sin DOM, para poder probarlas: el componente solo mide y llama.
 */

/** Aire entre el borde inferior de las barras fijas y el primer artículo. */
export const LIST_GAP_PX = 8

/** `"56px"` → 56. Cualquier cosa ilegible cuenta como 0 (la barra no existe). */
export function cssPx(value: string | null | undefined): number {
  const n = Number.parseFloat(value ?? '')
  return Number.isFinite(n) ? n : 0
}

/**
 * A dónde hacer scroll vertical tras cambiar de categoría para que el primer
 * artículo quede justo debajo de header + "¿Cómo lo recibes?" + categorías.
 *
 * `listTop` es la posición del inicio de la lista relativa al viewport
 * (getBoundingClientRect().top) y `stickyBottom` la suma de las barras fijas.
 * Devuelve `null` cuando la lista ya empieza visible debajo de las barras: si el
 * cliente está arriba (viendo el hero o el título), no se le mueve la página.
 */
export function listScrollTarget(listTop: number, scrollY: number, stickyBottom: number): number | null {
  const wanted = stickyBottom + LIST_GAP_PX
  if (listTop >= wanted) return null
  return Math.max(0, Math.round(scrollY + listTop - wanted))
}

/**
 * `scrollLeft` de la fila de pestañas para dejar la activa centrada, acotado a
 * lo que la fila puede desplazarse (sin hueco al inicio ni al final).
 */
export function centeredScrollLeft(
  pillLeft: number,
  pillWidth: number,
  rowWidth: number,
  rowScrollWidth: number,
): number {
  const max = Math.max(0, rowScrollWidth - rowWidth)
  const ideal = pillLeft - (rowWidth - pillWidth) / 2
  return Math.round(Math.min(max, Math.max(0, ideal)))
}
